import angular from 'angular';
import submitSuccessComponent from './submitSuccess.component';

let submitSuccessModule = angular.module('submitSuccess', []).component('submitSuccess', submitSuccessComponent);

export default submitSuccessModule;



// WEBPACK FOOTER //
// ./app/components/submitSuccess/submitSuccess.js